import { useCallback, useState } from 'react';

const useFollowUpDrawer = () => {
  const [selectedFollowUpId, setSelectedFollowUpId] = useState(null);
  const closeDrawer = useCallback(() => setSelectedFollowUpId(null), []);
  const selectFollowUp = useCallback((followUpId) => setSelectedFollowUpId(followUpId), []);

  return {
    selectedFollowUpId,
    closeDrawer,
    selectFollowUp,
  };
};

export default useFollowUpDrawer;
